import React, { useState } from 'react';

const genreOptions = [
  "Action", "Adventure", "Art", "Biography", "Comedy", "Coming-of-Age", "Courtroom drama", "Crime",
  "Documentary", "Drama", "Family", "Fantasy", "History", "Horror", "Legal", "Media", "Military",
  "Music", "Musical", "Mystery", "Political", "Reality", "Religious", "Romance", "Sci-Fi",
  "Teen", "Thriller", "War", "Western", "Workplace"
];

const moodOptions = [
  "Adrenaline-Packed", "Bold", "High-Stakes", "Heroic", "Cathartic", "Heartwarming", "Playful", "Silly",
  "Witty", "Poetic", "Raw", "Gritty", "Strategic", "Vengeful", "Epic", "Magical", "Reflective", "Emotional",
  "Terrifying", "Suspenseful", "Cerebral", "Uplifting", "Dreamy", "Expressive", "Futuristic", "Philosophical",
  "Spiritual", "Chaotic", "Rebellious", "Dark", "Psychological", "Patriotic", "Relatable"
];

const platformOptions = [
  "Netflix", "Hulu", "Prime Video", "Max", "Disney+", "Apple TV+", "Paramount+", "Peacock",
  "STARZ", "Showtime", "AMC+", "BET+", "Discovery+", "Sundance Now", "ALLBLK", "OWN", "UMC", "Pluto TV"
];

const commitmentOptions = ["Movie", "Limited Series", "Multi-Season"];

export default function Filters({ onChange }) {
  const [filter, setFilter] = useState({
    genre: '',
    mood: '',
    platform: '',
    commitment: ''
  });

  const handleSelect = (type, value) => {
    setFilter(prev => ({ ...prev, [type]: value }));
    onChange(type, value);
  };

  const resetFilters = () => {
    const cleared = { genre: '', mood: '', platform: '', commitment: '' };
    setFilter(cleared);
    Object.entries(cleared).forEach(([type, value]) => onChange(type, value));
  };

  return (
    <div className="flex flex-wrap gap-4 p-4 bg-white rounded shadow items-end">
      <Dropdown label="Genre" options={genreOptions} value={filter.genre} onSelect={(val) => handleSelect('genre', val)} />
      <Dropdown label="Mood" options={moodOptions} value={filter.mood} onSelect={(val) => handleSelect('mood', val)} />
      <Dropdown label="Platform" options={platformOptions} value={filter.platform} onSelect={(val) => handleSelect('platform', val)} />
      <Dropdown label="Commitment" options={commitmentOptions} value={filter.commitment} onSelect={(val) => handleSelect('commitment', val)} />

      {/* ✨ Reset Button */}
      <button
        className="bg-gray-200 hover:bg-gray-300 text-black px-4 py-2 rounded font-semibold"
        onClick={resetFilters}
      >
        Reset Filters
      </button>
    </div>
  );
}

function Dropdown({ label, options, value, onSelect }) {
  return (
    <div className="flex flex-col">
      <label className="font-semibold text-sm mb-1 text-gray-700">{label}</label>
      <select
        className="p-2 border rounded text-black"
        value={value}
        onChange={(e) => onSelect(e.target.value)}
      >
        <option value="">-- Select --</option>
        {options.map(opt => (
          <option key={opt} value={opt}>{opt}</option>
        ))}
      </select>
    </div>
  );
}